<template>
  <div class="technology_re">
   	<h2 class="title">深耕远程技术 追求卓越品质</h2>
		<div class="tabs_wrap" ref="tabs_wrap">
			<div class="tabs_box" ref="tabs_box">
				<div
					v-for="(item, index) in tabsList"
					:class="[`tabs_box_${index + 1}`, index + 1 == currIdx ? 'active' : '']"
					@click="chooseTabs(index + 1)" :key="item"
				>
					{{item}}
				</div>
				<div class="tabs_box_bg" :style="tabStyle"></div>
			</div>
		</div>
		<div class="content-wrap">
			<div
				v-for="(item, index) in itemList"
				v-touch:swipe.left="touchLeft"
				v-touch:swipe.right="touchRight"
				:class="['item_box', `item_box_${index + 1}`, index + 1 == currIdx ? 'active' : '']"
				:key="index"
			>
				<div class="img_box">
					<img :src="item.img.url" alt="" draggable="false" :style="index === 2 ? 'width:100%; height: auto;' : ''">
				</div>
				<div class="text_box">
					<div class="item_desc">{{ item.text.desc }}</div>
					<div class="detail_box">
						<div 
							v-for="detail in item.text.detailList"
							class="detail_item"
							:key="detail"
						>
							{{ detail }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<router-link to="/enterprise" class="dl_btn">免费试用</router-link>
  </div>
</template>

<script>
export default {
  name: "Technology",
  data() {
    return {
			currIdx: 1,
			tabsList: ['ZeroSync引擎', 'ToDesk编解码器', 'OTT SD-WAN'],
			itemList: [
				{
					img: {
						url: 'https://todeskcdnspeed.todesk.com/2023090416564760484b0b3705c0.png',
					},
					text: {
						desc: '自研ZeroSync引擎 全方位提升传输性能',
						detailList: [
							'ToDesk自主研发实时音视频的技术框架，从底层结构提升传输性能。通过带宽预测、拥堵优化等方式抵御网络波动，确保数据快速、稳定、精准传递。带宽利用率提升50%，接入网拥挤降低90%，缓存延迟低至9ms，综合丢包率低至0.03%。',
						],
					},
				},
				{
					img: {
						url: 'https://todeskcdnspeed.todesk.com/2023090416570560484b1c7032a0.png',
					},
					text: {
						desc: '突破画质新高度 为远程桌面而生',
						detailList: [
							'ToDesk视频编解码算法和硬件优化双管齐下、深度融合，自动调节编码方式，满足更多用户场景，提供更极致的高清流畅体验，释放硬件潜力，编码延时低至8ms。'
						],
					},
				},
				{
					img: {
						url: 'https://todeskcdnspeed.todesk.com/2023111715151660a53e5f6d9100.png',
					},
					text: {
						desc: '全球节点覆盖 智能连接路径规划',
						detailList: [
							'超10年的网络优化经验，将全球领先的SD-WAN服务引入远程桌面，实现全球任意两个节点间网络延时不超过120ms，终端到边缘节点延时不超过10ms。',
						],
					},
				}
			],
    };
  },
	computed: {
		tabStyle() {
			switch (this.currIdx) {
				case 1:
					return `left: ${18 / 375 * 100}vw; width: ${142.25 / 375 * 100}vw`
				case 2:
					return `left: ${159 / 375 * 100}vw; width: ${158.95 / 375 * 100}vw`
				case 3:
					return `left: ${317 / 375 * 100}vw; width: ${144 / 375 * 100}vw`
				default:
					return ''
			}
		}
	},
	watch: {
		currIdx(val) {
			if (val === 1) {
				this.$refs.tabs_wrap.scroll({
					left: 0,
					behavior: "smooth"
				})
				return
			}
			if (val === this.itemList.length) {
				const scrollRight = this.$refs.tabs_box.clientWidth - this.$refs.tabs_wrap.clientWidth
				this.$refs.tabs_wrap.scroll({
					left: scrollRight && scrollRight > 0 ? scrollRight : 130,
					behavior: "smooth"
				})
			}
		},
	},
  mounted() {
  },
  methods: {
    chooseTabs(index = 1) {
			this.currIdx = index
    },
		touchLeft() {
			if(this.currIdx == this.itemList.length){
        this.currIdx = 1;
      }else{
        this.currIdx ++
      }
		},
		touchRight() {
			if(this.currIdx == 1){
        this.currIdx = this.itemList.length;
      }else{
        this.currIdx --
      }
		}
  },
};
</script>

<style scoped lang="less">
.technology_re {
	width: 375px;
	min-height: 739px;
	background-color: #141821;
	position: relative;
	overflow: hidden;
	.title {
		padding-top: 38px;
		font-family: 'PingFang SC';
		font-weight: 500;
		font-size: 26px;
		line-height: 36px;
		color: #FFFFFF;
		text-align: center;
	}
	.tabs_wrap {
		width: 375px;
		height: 40px;
		overflow-x: auto;
		margin: 20px auto 0;
		-webkit-overflow-scrolling: touch;
		&::-webkit-scrollbar {
			display: none;
		}
	}
	.tabs_box {
		user-select: none;
		padding: 0 20px;
		width: 438px;
		height: 40px;
		justify-content: center;
		display: flex;
		position: relative;
		&_1,
		&_2,
		&_3 {
			height: 40px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: center;
			font-family: 'PingFang SC';
			font-weight: 400;
			font-size: 16px;
			color: #FFFFFF;
			transition: color 0.5s;
			cursor: pointer;
			z-index: 1;
			color: rgba(255, 255, 255, 0.6);
			margin-right: 8px;
			&.active {
				color: rgba(255, 255, 255, 1);
			}
    }
		&_1 {
			width: 142.25px;
    }
		&_2 {
			width: 158.95px;
    } 
		&_3 {
			width: 144px;
			margin-right: 0;
    }
    &_bg {
      position: absolute;
      left: 20px;
      width: 142.25px;
      height: 40px;
			box-sizing: border-box;
      background-color: transparent;
			border-radius: 67px;
      transition: all 0.3s;
			border: 1px solid rgba(255, 255, 255, 1);
      z-index: 0;
    }
  }
	.content-wrap {
		position: relative;
		margin: 16px auto 0;
		.item_box {
			touch-action: pan-y;
			width: 100%;
			box-sizing: border-box;
			position: absolute;
			top: 0;
			left: 50%;
			transform: translateX(-50%);
			transition: opacity 1s;
			opacity: 0;
			z-index: 0;
			&.active {
				opacity: 1;
				z-index: 1;
			}
			.img_box {
				height: 270px;
				overflow: visible;
				display: flex;
				align-items: center;
				justify-content: center;
				img {
					width: auto;
					height: 254.84px;
					display: block;
				}
			}
			.text_box {
				width: 100%;
				// margin-top: 12px;
				.item_desc {
					width: 335px;
					margin: 0 auto;
					color: #F7F9FC;
					font-family: PingFang SC;
					font-size: 22px;
					font-weight: 600;
					line-height: normal; 
					text-align: left;
				}
				.detail_box {
					.detail_item {
						width: 335px;
						margin: 14px auto 0;
						color: #F2F3F5;
						font-family: PingFang SC;
						font-size: 14px;
						font-weight: 400;
						line-height: 22px;
						letter-spacing: 0.5px; 
						text-align: left;
					}
				}
			}
		}
	}
	.dl_btn {
		position: absolute;
		bottom: 57px;
		left: 50%;
		transform: translateX(-50%);
		user-select: none;
		width: 180px;
		height: 40px;
		background-color: #0070F9;
		border-radius: 6px;
		font-family: 'PingFang SC';
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: background-color 0.3s;
		&:active {
			background-color: #1c87fd;
		}
	}
}
</style>